import clsx from 'clsx';
import { forwardRef, type TextareaHTMLAttributes } from 'react';

interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  /** Marks the field as failing validation — red border + focus ring. */
  invalid?: boolean;
}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  function Textarea({ className, invalid, ...rest }, ref) {
    return (
      <textarea
        ref={ref}
        aria-invalid={invalid || undefined}
        className={clsx(
          'w-full resize-y rounded-md border bg-[var(--input-bg)] px-2 py-1 text-xs text-[var(--text-primary)] outline-none transition',
          'sm:rounded-lg sm:px-3 sm:py-2 sm:text-sm',
          'min-h-[60px] sm:min-h-[80px]',
          invalid
            ? 'border-danger ring-1 ring-danger/40 focus:border-danger'
            : 'border-[var(--border-color)] focus:border-accent',
          className,
        )}
        {...rest}
      />
    );
  },
);
